module.exports = __webpack_public_path__ + "img/vasyr-2015.cd98ed22.jpg";